import { DataFieldStyled } from '@procurify/ui'
import styled from 'styled-components'

export const FinancialAccountBankingDetailsModalStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${DataFieldStyled} {
    text-wrap: nowrap;
  }
`
